'use strict';

document.documentElement.classList.add('js');

// Shared by every modal-like region (mobile menu, gallery zoom viewer)
// that traps Tab focus while open.
var FOCUSABLE_SELECTOR = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';

function trapTabFocus(container, event) {
  var focusable = Array.prototype.slice.call(container.querySelectorAll(FOCUSABLE_SELECTOR));
  if (focusable.length === 0) return;

  var first = focusable[0];
  var last = focusable[focusable.length - 1];

  if (event.shiftKey && document.activeElement === first) {
    event.preventDefault();
    last.focus();
  } else if (!event.shiftKey && document.activeElement === last) {
    event.preventDefault();
    first.focus();
  }
}

(function initMobileMenu() {
  var toggle = document.querySelector('[data-mobile-menu-toggle]');
  var menu = document.querySelector('[data-mobile-menu]');
  var overlay = document.querySelector('[data-mobile-menu-overlay]');
  var closeButton = document.querySelector('[data-mobile-menu-close]');

  if (!toggle || !menu || !overlay || !closeButton) return;

  function onKeydown(event) {
    if (event.key === 'Escape') {
      closeMenu();
      return;
    }

    if (event.key === 'Tab') {
      trapTabFocus(menu, event);
    }
  }

  function openMenu() {
    menu.classList.add('is-open');
    overlay.classList.add('is-open');
    menu.removeAttribute('inert');
    overlay.removeAttribute('inert');
    menu.setAttribute('aria-hidden', 'false');
    overlay.setAttribute('aria-hidden', 'false');
    toggle.setAttribute('aria-expanded', 'true');

    var firstFocusable = menu.querySelector(FOCUSABLE_SELECTOR);
    if (firstFocusable) firstFocusable.focus();

    document.addEventListener('keydown', onKeydown);
  }

  function closeMenu() {
    menu.classList.remove('is-open');
    overlay.classList.remove('is-open');
    menu.setAttribute('inert', '');
    overlay.setAttribute('inert', '');
    menu.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('aria-hidden', 'true');
    toggle.setAttribute('aria-expanded', 'false');

    document.removeEventListener('keydown', onKeydown);
    toggle.focus();
  }

  toggle.addEventListener('click', function () {
    var isOpen = menu.classList.contains('is-open');
    if (isOpen) {
      closeMenu();
    } else {
      openMenu();
    }
  });

  closeButton.addEventListener('click', closeMenu);
  overlay.addEventListener('click', closeMenu);
})();

(function initStickyHeader() {
  var header = document.querySelector('[data-site-header]');
  if (!header) return;

  function updateHeaderShadow() {
    header.classList.toggle('site-header--scrolled', window.scrollY > 0);
  }

  updateHeaderShadow();
  window.addEventListener('scroll', updateHeaderShadow, { passive: true });
})();

(function initProductGallery() {
  var galleries = document.querySelectorAll('[data-product-gallery]');

  galleries.forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
    var dots = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-dot]'));
    var prevButton = gallery.querySelector('[data-gallery-prev]');
    var nextButton = gallery.querySelector('[data-gallery-next]');
    var counterCurrent = gallery.querySelector('[data-gallery-counter-current]');

    if (!main) return;

    // Scoped to `main`, not `gallery`: the zoom viewer (if enabled)
    // renders its own copy of every slide inside this same gallery
    // wrapper, and its slides carry the same [data-gallery-slide]
    // attribute. Querying from `gallery` would silently mix the two
    // sets together.
    var slides = Array.prototype.slice.call(main.querySelectorAll('[data-gallery-slide]'));
    if (!slides.length) return;

    function setActive(index) {
      [thumbs, dots].forEach(function (items) {
        items.forEach(function (item) {
          var isActive = item.getAttribute('data-gallery-index') === String(index);
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
      });

      slides.forEach(function (slide) {
        slide.classList.toggle(
          'is-active',
          slide.getAttribute('data-gallery-index') === String(index),
        );
      });

      if (counterCurrent) {
        counterCurrent.textContent = String(index + 1);
      }
    }

    function getCurrentIndex() {
      var activeSlide = slides.filter(function (slide) {
        return slide.classList.contains('is-active');
      })[0];
      return activeSlide ? Number(activeSlide.getAttribute('data-gallery-index')) : 0;
    }

    function goToIndex(index) {
      var slide = main.querySelector('[data-gallery-slide][data-gallery-index="' + index + '"]');
      if (slide) {
        main.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }
      setActive(index);
    }

    function step(delta) {
      var total = slides.length;
      goToIndex((getCurrentIndex() + delta + total) % total);
    }

    function bindClick(item) {
      item.addEventListener('click', function () {
        goToIndex(Number(item.getAttribute('data-gallery-index')));
      });
    }

    thumbs.forEach(bindClick);
    dots.forEach(bindClick);

    if (prevButton)
      prevButton.addEventListener('click', function () {
        step(-1);
      });
    if (nextButton)
      nextButton.addEventListener('click', function () {
        step(1);
      });

    function bindArrowKeys(items) {
      items.forEach(function (item, position) {
        item.addEventListener('keydown', function (event) {
          var delta = 0;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
            delta = 1;
          } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
            delta = -1;
          } else {
            return;
          }

          event.preventDefault();
          var nextPosition = (position + delta + items.length) % items.length;
          var nextItem = items[nextPosition];
          nextItem.focus();
          goToIndex(Number(nextItem.getAttribute('data-gallery-index')));
        });
      });
    }

    bindArrowKeys(thumbs);
    bindArrowKeys(dots);

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              setActive(Number(entry.target.getAttribute('data-gallery-index')));
            }
          });
        },
        { root: main, threshold: 0.6 },
      );

      slides.forEach(function (slide) {
        observer.observe(slide);
      });
    }
  });
})();

(function initGalleryViewer() {
  var galleries = document.querySelectorAll('[data-product-gallery]');

  galleries.forEach(function (gallery) {
    var viewer = gallery.querySelector('[data-gallery-viewer]');
    var triggers = Array.prototype.slice.call(
      gallery.querySelectorAll('[data-gallery-zoom-trigger]'),
    );
    if (!viewer || !triggers.length) return;

    var viewerMain = viewer.querySelector('[data-gallery-viewer-main]');
    var viewerSlides = Array.prototype.slice.call(
      viewerMain.querySelectorAll('[data-gallery-slide]'),
    );
    var closeButton = viewer.querySelector('[data-gallery-viewer-close]');
    var backdrop = viewer.querySelector('[data-gallery-viewer-backdrop]');
    var prevButton = viewer.querySelector('[data-gallery-viewer-prev]');
    var nextButton = viewer.querySelector('[data-gallery-viewer-next]');
    var counterCurrent = viewer.querySelector('[data-gallery-viewer-counter-current]');

    if (!viewerMain || !viewerSlides.length) return;

    var lastFocused = null;

    function showSlide(index) {
      viewerSlides.forEach(function (slide) {
        slide.classList.toggle(
          'is-active',
          slide.getAttribute('data-gallery-index') === String(index),
        );
      });
      viewerMain.setAttribute('data-current-index', String(index));
      if (counterCurrent) counterCurrent.textContent = String(index + 1);
    }

    function currentIndex() {
      return Number(viewerMain.getAttribute('data-current-index') || 0);
    }

    function step(delta) {
      var total = viewerSlides.length;
      showSlide((currentIndex() + delta + total) % total);
    }

    function onKeydown(event) {
      if (event.key === 'Escape') {
        closeViewer();
        return;
      }

      if (event.key === 'ArrowRight') {
        step(1);
        return;
      }

      if (event.key === 'ArrowLeft') {
        step(-1);
        return;
      }

      if (event.key === 'Tab') {
        trapTabFocus(viewer, event);
      }
    }

    function openViewer(startIndex) {
      lastFocused = document.activeElement;
      showSlide(startIndex);
      viewer.classList.add('is-open');
      viewer.removeAttribute('inert');
      viewer.setAttribute('aria-hidden', 'false');
      document.addEventListener('keydown', onKeydown);
      if (closeButton) closeButton.focus();
    }

    function closeViewer() {
      viewer.classList.remove('is-open');
      viewer.setAttribute('inert', '');
      viewer.setAttribute('aria-hidden', 'true');
      document.removeEventListener('keydown', onKeydown);
      if (lastFocused) lastFocused.focus();
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        openViewer(Number(trigger.getAttribute('data-gallery-index')));
      });
    });

    if (closeButton) closeButton.addEventListener('click', closeViewer);
    if (backdrop) backdrop.addEventListener('click', closeViewer);
    if (prevButton)
      prevButton.addEventListener('click', function () {
        step(-1);
      });
    if (nextButton)
      nextButton.addEventListener('click', function () {
        step(1);
      });
  });
})();

(function initProductForm() {
  var wrappers = document.querySelectorAll('[data-product-hero]');

  wrappers.forEach(function (wrapper) {
    var form = wrapper.querySelector('form');
    if (!form) return;

    var pills = Array.prototype.slice.call(form.querySelectorAll('[data-product-option]'));
    var variantsScript = form.querySelector('[data-product-variants]');
    var variantIdInput = form.querySelector('[data-product-variant-id]');
    var submitButton = form.querySelector('.product-hero__cta');

    // No variantsScript means the product has only its default variant
    // (sections/main-product.liquid doesn't render the picker or this
    // script in that case) — nothing to match, server-rendered Liquid
    // is already correct on its own.
    if (!pills.length || !variantsScript || !variantIdInput) return;

    var variants;
    try {
      variants = JSON.parse(variantsScript.textContent);
    } catch (error) {
      return;
    }

    var addToCartText = wrapper.getAttribute('data-add-to-cart-text');
    var soldOutText = wrapper.getAttribute('data-sold-out-text');

    var optionGroups = {};
    pills.forEach(function (pill) {
      var index = pill.getAttribute('data-option-index');
      if (!optionGroups[index]) optionGroups[index] = [];
      optionGroups[index].push(pill);
    });
    var optionIndexes = Object.keys(optionGroups).sort(function (a, b) {
      return Number(a) - Number(b);
    });

    function selectedValues() {
      return optionIndexes.map(function (index) {
        var activePill = optionGroups[index].filter(function (pill) {
          return pill.classList.contains('is-active');
        })[0];
        return activePill ? activePill.getAttribute('data-value') : null;
      });
    }

    function findVariant() {
      var selected = selectedValues();
      return variants.filter(function (variant) {
        return variant.options.every(function (value, index) {
          return value === selected[index];
        });
      })[0];
    }

    function applyVariant(variant) {
      if (!variant) return;

      variantIdInput.value = variant.id;

      document.querySelectorAll('[data-variant-price]').forEach(function (block) {
        block.hidden = block.getAttribute('data-variant-id') !== String(variant.id);
      });

      if (submitButton) {
        submitButton.disabled = !variant.available;
        submitButton.textContent = variant.available ? addToCartText : soldOutText;
      }

      // Sticky Add to Cart (Ticket 016) has its own button reflecting
      // the same variant availability — same source of truth, not a
      // second variant-matching system.
      var stickyButton = document.querySelector('.sticky-cart__cta');
      if (stickyButton) {
        stickyButton.disabled = !variant.available;
        stickyButton.textContent = variant.available ? addToCartText : soldOutText;
      }
    }

    function selectPill(pill) {
      var index = pill.getAttribute('data-option-index');
      optionGroups[index].forEach(function (sibling) {
        var isActive = sibling === pill;
        sibling.classList.toggle('is-active', isActive);
        sibling.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
      applyVariant(findVariant());
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        selectPill(pill);
      });

      pill.addEventListener('keydown', function (event) {
        var groupPills = optionGroups[pill.getAttribute('data-option-index')];
        var positionInGroup = groupPills.indexOf(pill);
        var delta = 0;

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          delta = 1;
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          delta = -1;
        } else {
          return;
        }

        event.preventDefault();
        var nextPosition = (positionInGroup + delta + groupPills.length) % groupPills.length;
        var nextPill = groupPills[nextPosition];
        nextPill.focus();
        selectPill(nextPill);
      });
    });
  });
})();

(function initAddToCartLoadingState() {
  var forms = document.querySelectorAll('[data-product-hero] form');

  forms.forEach(function (form) {
    var submitButton = form.querySelector('.product-hero__cta');
    if (!submitButton) return;

    form.addEventListener('submit', function () {
      if (submitButton.disabled) return;

      submitButton.classList.add('is-loading');
      submitButton.setAttribute('aria-busy', 'true');

      // Safety net: a native form submission navigates away on success,
      // so this normally never fires. It only matters if submission is
      // ever blocked (e.g. a future validation step) — without it the
      // button would otherwise spin forever.
      window.setTimeout(function () {
        submitButton.classList.remove('is-loading');
        submitButton.removeAttribute('aria-busy');
      }, 8000);
    });
  });
})();

(function initQuantitySelector() {
  var selectors = document.querySelectorAll('[data-quantity-selector]');

  selectors.forEach(function (selector) {
    var input = selector.querySelector('[data-quantity-input]');
    var decreaseButton = selector.querySelector('[data-quantity-decrease]');
    var increaseButton = selector.querySelector('[data-quantity-increase]');

    if (!input || !decreaseButton || !increaseButton) return;

    function currentValue() {
      var value = parseInt(input.value, 10);
      return isNaN(value) || value < 1 ? 1 : value;
    }

    // Setting .value programmatically never fires a native "change"
    // event on its own — only direct user input does. The +/- buttons
    // dispatch one manually so anything listening for real quantity
    // changes (e.g. Ticket 016's sticky cart sync) sees button-driven
    // changes too, not just typed-and-blurred ones. The input's own
    // "change" handler re-normalizes silently instead, so this can't
    // recurse: it only re-dispatches when the value actually changes,
    // and by the time its own listener re-runs setValue the value is
    // already normalized, so nothing fires a second time.
    function setValue(value, options) {
      var silent = options && options.silent;
      var normalized = String(Math.max(1, value));
      var changed = input.value !== normalized;
      input.value = normalized;
      if (changed && !silent) {
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    decreaseButton.addEventListener('click', function () {
      setValue(currentValue() - 1);
    });

    increaseButton.addEventListener('click', function () {
      setValue(currentValue() + 1);
    });

    input.addEventListener('change', function () {
      setValue(currentValue(), { silent: true });
    });
  });
})();

(function initUrgencyCountdown() {
  var timers = document.querySelectorAll('[data-urgency-countdown-timer]');
  if (!timers.length) return;

  function pad(value) {
    return value < 10 ? '0' + value : String(value);
  }

  function update() {
    var now = new Date();
    var endOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999);
    var remainingMs = Math.max(0, endOfDay.getTime() - now.getTime());
    var totalSeconds = Math.floor(remainingMs / 1000);
    var hours = Math.floor(totalSeconds / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;
    var formatted = pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);

    timers.forEach(function (timer) {
      timer.textContent = formatted;
    });
  }

  update();
  setInterval(update, 1000);
})();

(function initBundleTiers() {
  var wrappers = document.querySelectorAll('[data-bundle-tiers]');
  if (!wrappers.length) return;

  wrappers.forEach(function (wrapper) {
    var hero = wrapper.closest('[data-product-hero]');
    var quantityInput = hero && hero.querySelector('[data-quantity-input]');
    var options = Array.prototype.slice.call(wrapper.querySelectorAll('[data-bundle-tier]'));

    if (!quantityInput || !options.length) return;

    function syncSelection() {
      var current = String(parseInt(quantityInput.value, 10) || 1);
      options.forEach(function (option) {
        var isSelected = option.getAttribute('data-tier-qty') === current;
        option.classList.toggle('is-selected', isSelected);
        option.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });
    }

    options.forEach(function (option) {
      option.addEventListener('click', function () {
        quantityInput.value = option.getAttribute('data-tier-qty');
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        syncSelection();
      });
    });

    quantityInput.addEventListener('change', syncSelection);
    syncSelection();
  });
})();

(function initScrollAnimations() {
  var animatedElements = document.querySelectorAll('[data-animate]');
  if (!animatedElements.length) return;

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) return;

  if (!('IntersectionObserver' in window)) {
    animatedElements.forEach(function (el) {
      el.classList.add('is-visible');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.2 },
  );

  animatedElements.forEach(function (el) {
    observer.observe(el);
  });
})();

(function initFaqAccordion() {
  var accordions = document.querySelectorAll('[data-faq-accordion]');

  accordions.forEach(function (accordion) {
    var allowMultiple = accordion.getAttribute('data-allow-multiple') === 'true';
    var items = Array.prototype.slice.call(accordion.querySelectorAll('[data-faq-item]'));

    function setItemState(item, isOpen) {
      var trigger = item.querySelector('[data-faq-trigger]');
      var panel = item.querySelector('[data-faq-panel]');

      item.classList.toggle('is-open', isOpen);
      if (trigger) trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (panel) panel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    }

    function toggleItem(item) {
      var isOpen = item.classList.contains('is-open');

      if (!isOpen && !allowMultiple) {
        items.forEach(function (otherItem) {
          if (otherItem !== item) setItemState(otherItem, false);
        });
      }

      setItemState(item, !isOpen);
    }

    items.forEach(function (item) {
      var trigger = item.querySelector('[data-faq-trigger]');
      if (!trigger) return;

      trigger.addEventListener('click', function () {
        toggleItem(item);
      });

      trigger.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          setItemState(item, false);
          trigger.focus();
        }
      });
    });
  });
})();

(function initStickyAddToCart() {
  var stickyBars = document.querySelectorAll('[data-sticky-cart]');
  if (!stickyBars.length) return;

  var hero = document.querySelector('[data-product-hero]');
  if (!hero) return;

  var realForm = hero.querySelector('form');
  var realQuantityInput = hero.querySelector('[data-quantity-input]');

  stickyBars.forEach(function (stickyBar) {
    var stickyQuantityInput = stickyBar.querySelector('[data-quantity-input]');
    var stickyCta = stickyBar.querySelector('.sticky-cart__cta');

    function show() {
      stickyBar.classList.add('is-visible');
      stickyBar.removeAttribute('inert');
      stickyBar.setAttribute('aria-hidden', 'false');

      // Reflect whatever quantity is currently set in the real form —
      // the two inputs aren't continuously synced in both directions,
      // only refreshed at the moment the bar actually becomes visible.
      if (realQuantityInput && stickyQuantityInput) {
        stickyQuantityInput.value = realQuantityInput.value;
      }
    }

    function hide() {
      stickyBar.classList.remove('is-visible');
      stickyBar.setAttribute('inert', '');
      stickyBar.setAttribute('aria-hidden', 'true');
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            hide();
          } else {
            show();
          }
        });
      });
      observer.observe(hero);
    }

    if (stickyQuantityInput && realQuantityInput) {
      stickyQuantityInput.addEventListener('change', function () {
        realQuantityInput.value = stickyQuantityInput.value;
      });
    }

    if (stickyCta && realForm) {
      stickyCta.addEventListener('click', function (event) {
        event.preventDefault();
        if (stickyCta.disabled) return;

        stickyCta.classList.add('is-loading');

        if (realForm.requestSubmit) {
          realForm.requestSubmit();
        } else {
          realForm.submit();
        }
      });
    }
  });
})();
